import React, { useState, useEffect,useCallback } from "react";
import DataGrid, {
  Column,
  Export,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Selection,
  Scrolling,
  LoadPanel,
  SearchPanel,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnChooserSelection,
  Position,
  MasterDetail,
  Pager,
  Paging,
} from "devextreme-react/data-grid";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";
import "whatwg-fetch";
import { useStyles } from "../../Styles.js";
import { createStore } from "devextreme-aspnet-data-nojquery";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import { api_path } from "../../shared.js";
import Select from "react-select";
import axios from "axios";
import DataMyneMasterDetailView from "./DataMyneMasterDetailView";
import DateBox from "devextreme-react/date-box";
import { MultiSelect } from "react-multi-select-component";
import useDeviceSize from "../../hooks/useDeviceSize";
export function DatamyneDataGrid() {
  const [width, height] = useDeviceSize();
    const [loadPanelEnabled, setLoadPanelEnabled] = useState(true);
    const onContentReady = useCallback(() => {
      setLoadPanelEnabled(false);
    }, []);
  const classes = useStyles();
  const [getYear, setYear] = useState([]);
  const [yearList, setYearList] = useState([]);
  const [selectYear, setSelectYear] = useState([]);
  const [getMonth, setMonth] = useState([]);
  const [monthList, setMonthList] = useState([]);
  const [selectMonth, setSelectMonth] = useState([]);
  const [getShipper, setShipper] = useState([]);
  const [shipperList, setShipperList] = useState([]);
  const [selectShipper, setSelectShipper] = useState([]);
  const [getCommodity, setCommodity] = useState([]);
  const [commodityList, setCommodityList] = useState([]);
  const [selectCommodity, setSelectCommodity] = useState([]);
  const [getSearchStatus, setSearchStatus] = useState(0);
  const [getTotalCount, setTotalCount] = useState(0);

  const [consigneeList, setConsigneeList] = useState([]);
  const [selectConsignee, setSelectConsignee] = useState([]);
  const [getConsignee, setConsignee] = useState([]);

  const [carrierList, setCarrierList] = useState([]);
  const [selectCarrier, setSelectCarrier] = useState([]);
  const [getCarrier, setCarrier] = useState([]);

  const [portList, setPortList] = useState([]);
  const [selectPort, setSelectPort] = useState([]);
  const [getPort, setPort] = useState([]);

  const [getResult, setResult] = useState("");
  const [getErrMsg, setErrMsg] = useState("");
  const pageSizes = [25, 50, 100];
  const [selectedValue, setSelectedValue] = useState("option1");
  const [getDateStr, setDateStr] = useState(
    "Please click Search button to refresh data."
  );
  const now = new Date();
  const dateLabel = { "aria-label": "Date" };
  var date = new Date();
  var firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
  var lastDay = new Date(date.getFullYear(), date.getMonth(), 0);
  const formattedfirstDay = firstDay
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");

  const formattedlastDay = lastDay
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");

  const [getDateFrom, setDateFrom] = useState(formattedfirstDay);
  const [getDateTo, setDateTo] = useState(formattedlastDay);
  const [getMinDate, setMinDate] = useState(null);
  const [getFlag, setFlag] = useState("");
  useEffect(() => {
    setResult("");
    fetchCommodity();
  }, []);
  const handleRadioChange = (value) => {
    setSelectedValue(value);
    setErrMsg("");
  };
  function formatDate(value) {
    let date = new Date(value);
    const day = date.toLocaleString("default", { day: "2-digit" });
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.toLocaleString("default", { year: "numeric" });
    return day + "-" + month + "-" + year;
  }
  const handleSearch = (e) => {
    if (
      selectShipper.length == 0 &&
      selectConsignee.length == 0 &&
      selectCarrier.length == 0 &&
      selectPort.length == 0 &&
      selectCommodity.length == 0
    ) {
      setSearchStatus(0);
      setResult("Please select shipper,consignee,carrier or commodity.");
      setDateStr("");
    } else {
      setSearchStatus(1);
      setResult("");
      // setDateStr(
      //   "shipper1..." +selectShipper+
      //   "shipper2..." +selectConsignee+
      //     ""
      // );
      setDateStr(
        " [ ETA from " +
          formatDate(getDateFrom) +
          " To " +
          formatDate(getDateTo) +
          " ]"
      );
      //setResult("Found " + numberFormat(getTotalCount) +" items")
    }
  };
  const handleClearInputClick = () => {
    setDateStr("Please click Search button to refresh data.");
    setSearchStatus(0);
    setMonth([]);
    setSelectMonth([]);
    setYear([]);
    setSelectYear([]);
    setShipper([]);
    setSelectShipper([]);
    setConsignee([]);
    setSelectConsignee([]);
    setCarrier([]);
    setSelectCarrier([]);
    setCommodity([]);
    setSelectCommodity([]);
    setPort([]);
    setSelectPort([]);
    setDateFrom(formattedfirstDay);
    setDateTo(formattedlastDay);
    setResult("");
    setDateStr("");
    setTotalCount(0);
  };

  const styles = {
    radioButton: {
      padding: "12px 16px",
      borderRadius: "8px",
      margin: "8px",
      border: "2px solid #007BFF",
      background: "#fff",
      display: "inline",
      alignItems: "center",
      justifyContent: "center",
      width: "280px",
      cursor: "pointer",
      transition: "background-color 0.3s, color 0.3s",
    },
    selected: {
      background: "#007BFF",
      color: "#fff",
      borderColor: "#007BFF",
    },
    list: {
      listStyleType: "none",
      padding: 0,
      textAlign: "center",
      display: "inline-flex",
    },
  };
  const CustomRadioButton = ({ label, selected, onSelect }) => (
    <li>
      <button
        style={{
          ...styles.radioButton,
          ...(selected ? styles.selected : {}),
        }}
        onClick={onSelect}
      >
        {label}
      </button>
    </li>
  );
  const url =
    api_path +
    "/DATAMYNE.php?search=" +
    getSearchStatus +
    "&parMonth=" +
    selectMonth +
    "&parYear=" +
    selectYear +
    "&parShipper=" +
    selectShipper +
    "&parConsignee=" +
    selectConsignee +
    "&parCom=" +
    selectCommodity +
    "&parCarrier=" +
    selectCarrier +
    "&parPort=" +
    selectPort +
    "&parDateFrom=" +
    getDateFrom +
    "&parDateTo=" +
    getDateTo;

  const dataSource = createStore({
    key: "Bill_of_Lading_Nbr",
    loadUrl: `${url}`,
  });
  const onValueChangedDateFrom = React.useCallback((e) => {
    setSearchStatus(0);
    const dateFrom = new Date(e.value);
    const formattedDateFrom = dateFrom
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    setDateFrom(formattedDateFrom);
    setMinDate(formattedDateFrom);
    setShipper(null);
    setCommodity(null);
  }, []);
  const onValueChangedDateTo = React.useCallback((e) => {
    setSearchStatus(0);
    const dateTo = new Date(e.value);
    const formattedDateTo = dateTo
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    setDateTo(formattedDateTo);
    setShipper(null);
    setCommodity(null);
  }, []);
  const columnChooserModes = [
    {
      key: "dragAndDrop",
      name: "Drag and drop",
    },
    {
      key: "select",
      name: "Select",
    },
  ];
  const optionsYear = [
    { value: "2023", label: "2023" },
    { value: "2024", label: "2024" },
  ];
  const optionsMonth = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
    { value: "7", label: "7" },
    { value: "8", label: "8" },
    { value: "9", label: "9" },
    { value: "10", label: "10" },
    { value: "11", label: "11" },
    { value: "12", label: "12" },
  ];

  const handleYearChange = (obj) => {
    setDateStr("Please click Search button to refresh data.");
    setSearchStatus(0);
    setSelectYear(obj.value);
    setYear({ value: obj.value, label: obj.label });
  };
  const handleMonthChange = (obj) => {
    setDateStr("Please click Search button to refresh data.");
    setSearchStatus(0);
    setSelectMonth(obj.value);
    setMonth({ value: obj.value, label: obj.label });
    // console.log(value.join(', '))
  };
  useEffect(() => {
    const getShipperDropdown = async () => {
      const resstate = await fetch(
        api_path +
          `/DATAMYNE_SHIPPER.php?parDateFrom=${getDateFrom}&parDateTo=${getDateTo}`
      );
      const getst = resstate.json();

      setShipperList(await getst);
    };
    getShipperDropdown().then();
  }, [getDateFrom, getDateTo]);

  const handleShipperChange = (obj) => {
    setResult("");
    setDateStr("Please click Search button to refresh data.");
    setSearchStatus(0);
    //if (obj === null) {

    //} else {
    // setSelectShipper(
    //   Array.isArray(obj) ? obj.map((x) => x.value).join("|") : []
    // );
    // }
    setSelectShipper(
      Array.isArray(obj) ? obj.map((x) => x.value).join("|") : []
    );
    setShipper({
      value: obj.Shipper_name,
      label: obj.Shipper_name,
    });
  };
  useEffect(() => {
    const getConsigneeDropdown = async () => {
      const resstate = await fetch(
        api_path +
          `/DATAMYNE_CONSIGNEE.php?parDateFrom=${getDateFrom}&parDateTo=${getDateTo}`
      );
      const getst = resstate.json();

      setConsigneeList(await getst);
    };
    getConsigneeDropdown().then();
  }, [getDateFrom, getDateTo]);
  const handleConsigneeChange = (obj) => {
    setResult("");
    setDateStr("Please click Search button to refresh data.");
    setSearchStatus(0);
    setSelectConsignee(
      Array.isArray(obj) ? obj.map((x) => x.value).join("|") : []
    );
    setConsignee({
      value: obj.Consignee_name,
      label: obj.Consignee_name,
    });
  };
  useEffect(() => {
    const getCarrierDropdown = async () => {
      const resstate = await fetch(
        api_path +
          `/DATAMYNE_CARRIER.php?parDateFrom=${getDateFrom}&parDateTo=${getDateTo}`
      );
      const getst = resstate.json();

      setCarrierList(await getst);
    };
    getCarrierDropdown().then();
  }, [getDateFrom, getDateTo]);
  const handleCarrierChange = (obj) => {
    setResult("");
    setDateStr("Please click Search button to refresh data.");
    setSearchStatus(0);
    setSelectCarrier(
      Array.isArray(obj) ? obj.map((x) => x.value).join("|") : []
    );
    setCarrier({
      value: obj.Carrier_name,
      label: obj.Carrier_name,
    });
  };
  useEffect(() => {
    const getPortDropdown = async () => {
      const resstate = await fetch(
        api_path +
          `/DATAMYNE_PORT.php?parDateFrom=${getDateFrom}&parDateTo=${getDateTo}`
      );
      const getst = resstate.json();

      setPortList(await getst);
    };
    getPortDropdown().then();
  }, [getDateFrom, getDateTo]);
  const handlePortChange = (obj) => {
    setResult("");
    setDateStr("Please click Search button to refresh data.");
    setSearchStatus(0);
    setSelectPort(Array.isArray(obj) ? obj.map((x) => x.value).join("|") : []);
    setPort({
      value: obj.PORT_NAME,
      label: obj.PORT_NAME,
    });
  };
  const fetchCommodity = () => {
    axios
      .get(api_path + `/DATAMYNE_COMMODITY.php`)
      .then((response) => {
        setCommodityList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleCommodityChange = (obj) => {
    setResult("");
    setDateStr("Please click Search button to refresh data.");
    setSearchStatus(0);
    setSelectCommodity(obj.commodity_code);
    setCommodity({
      commodity_code: obj.commodity_code,
      commodity_name: obj.commodity_name,
    });
  };
  const searchEditorOptions = { placeholder: "Search column" };
  const columnChooserModeLabel = { "aria-label": "Column Chooser Mode" };
  const onExporting = (e: DataGridTypes.ExportingEvent) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Main sheet");
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          "Datamyne.xlsx"
        );
      });
    });
  };
  const cellPrepared = (e) => {
    //console.log("count ..." + e.component.totalCount())
    setTotalCount(e.component.totalCount());
  };
  //Column Chooser
  const [mode, setMode] = React.useState(columnChooserModes[1].key);
  const [searchEnabled, setSearchEnabled] = React.useState(true);
  const [allowSelectAll, setAllowSelectAll] = React.useState(true);
  const [selectByClick, setSelectByClick] = React.useState(true);
  const [recursive, setRecursive] = React.useState(true);
  const isDragMode = mode === columnChooserModes[0].key;
  const onModeValueChanged = React.useCallback((e) => {
    setMode(e.value);
  }, []);
  const onSearchEnabledValueChanged = React.useCallback((e) => {
    setSearchEnabled(e.value);
  }, []);
  const onAllowSelectAllValueChanged = React.useCallback((e) => {
    setAllowSelectAll(e.value);
  }, []);
  const onSelectByClickValueChanged = React.useCallback((e) => {
    setSelectByClick(e.value);
  }, []);
  const onRecursiveValueChanged = React.useCallback((e) => {
    setRecursive(e.value);
  }, []);

  //end column chooser
  const numberFormat = (value) =>
    new Intl.NumberFormat("en-IN", {}).format(value);
  const Search = () => {
    const [showResults, setShowResults] = React.useState(false);
    const onClick = () => setShowResults(true);
    return (
      <div>
        <input type="button" value="Search" onClick={onClick} />
        {showResults ? <Results /> : null}
      </div>
    );
  };
  const Results = () => (
    <div id="results" className="search-results">
      Some Results
    </div>
  );

  function showSelectYear() {
    return (
      <>
        <label>Year</label>
        <span className="red">*</span>
        <Select
          styles={{
            menu: (provided) => ({ ...provided, zIndex: 9999 }),
          }}
          value={getYear}
          options={optionsYear}
          onChange={handleYearChange}
        />
      </>
    );
  }
  function showSelectMonth() {
    return (
      <>
        <label>Month</label>
        <span className="red">*</span>
        <Select
          styles={{
            menu: (provided) => ({ ...provided, zIndex: 9999 }),
          }}
          placeholder="Select"
          value={getMonth}
          options={optionsMonth}
          onChange={handleMonthChange}
        />
      </>
    );
  }
  function showDateFrom() {
    return (
      <>
        <label>From</label>
        <span className="red">*</span>
        <DateBox
          styles={{
            menu: (provided) => ({ ...provided, zIndex: 9999 }),
          }}
          defaultValue={now}
          inputAttr={dateLabel}
          type="date"
          displayFormat="dd/MM/yyyy"
          value={getDateFrom}
          onValueChanged={onValueChangedDateFrom}
        />
      </>
    );
  }
  function showDateTo() {
    return (
      <>
        <label>To</label>
        <span className="red">*</span>

        <DateBox
          defaultValue={now}
          inputAttr={dateLabel}
          type="date"
          displayFormat="dd/MM/yyyy"
          value={getDateTo}
          min={getMinDate}
          onValueChanged={onValueChangedDateTo}
        />
      </>
    );
  }
  const [modeSize, setModeSize] = useState("widget");
  return (
    <Container maxWidth="xl">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          &nbsp;
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <label className="head">Datamyne</label>
      </Grid>
      {/* <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <ul style={styles.list}>
            <CustomRadioButton
              label="Filter by year and date"
              selected={selectedValue === "option1"}
              onSelect={() => handleRadioChange("option1")}
            />
            <CustomRadioButton
              label="Filter by date and shipper"
              selected={selectedValue === "option2"}
              onSelect={() => handleRadioChange("option2")}
            />
            <CustomRadioButton
              label="Filter by date and commodity"
              selected={selectedValue === "option3"}
              onSelect={() => handleRadioChange("option3")}
            />
          </ul>
        </Grid>
      </Grid> */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={1}>
          <label>ETA From</label>
          <span className="red">*</span>
          <DateBox
            styles={{
              menu: (provided) => ({ ...provided, zIndex: 9999 }),
            }}
            defaultValue={now}
            inputAttr={dateLabel}
            type="date"
            displayFormat="dd/MM/yyyy"
            value={getDateFrom}
            onValueChanged={onValueChangedDateFrom}
          />
        </Grid>
        <Grid item xs={12} sm={1}>
          <label>ETA To</label>
          <span className="red">*</span>

          <DateBox
            defaultValue={now}
            inputAttr={dateLabel}
            type="date"
            displayFormat="dd/MM/yyyy"
            value={getDateTo}
            min={getMinDate}
            onValueChanged={onValueChangedDateTo}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>Shipper</label>

          <MultiSelect
            className="multiselect1"
            options={shipperList}
            value={shipperList.filter((obj) =>
              selectShipper.includes(obj.value)
            )}
            onChange={handleShipperChange}
            labelledBy="Select"
            hasSelectAll={false}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>Consignee</label>
          <MultiSelect
            className="multiselect2"
            options={consigneeList}
            value={consigneeList.filter((obj) =>
              selectConsignee.includes(obj.value)
            )}
            onChange={handleConsigneeChange}
            labelledBy="Select"
            hasSelectAll={false}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>Carrier</label>
          <MultiSelect
            className="multiselect2"
            options={carrierList}
            value={carrierList.filter((obj) =>
              selectCarrier.includes(obj.value)
            )}
            onChange={handleCarrierChange}
            labelledBy="Select"
            hasSelectAll={false}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>PORT</label>
          <MultiSelect
            className="multiselect2"
            options={portList}
            value={portList.filter((obj) => selectPort.includes(obj.value))}
            onChange={handlePortChange}
            labelledBy="Select"
            hasSelectAll={false}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <label>Commodity</label>
          <Select
            styles={{
              menu: (provided) => ({ ...provided, zIndex: 997 }),
            }}
            placeholder="Select..."
            value={getCommodity}
            options={commodityList}
            onChange={handleCommodityChange}
            getOptionLabel={(x) => x.commodity_name}
            getOptionValue={(x) => x.commodity_code}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={9}>
          <div className="labelError">{getResult}</div>
          <div className="labelResult">
            {/* {getTotalCount >0 && <div style={{ marginTop: 0, lineHeight: '25px' }}>
        <div> Found data: {numberFormat(getTotalCount)} items&nbsp;</div>
      </div>} */}
            {getDateStr}
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={3}
          style={{ display: "flex" }}
          justify="flex-end"
        >
          <Button
            className="searchButton"
            type="button"
            variant="outlined"
            color="primary"
            onClick={handleClearInputClick}
          >
            Clear Filter
          </Button>
          &nbsp;&nbsp;&nbsp;
          <Button
            className="searchButton"
            type="button"
            variant="contained"
            color="primary"
            onClick={handleSearch}
          >
            Search
          </Button>
        </Grid>
      </Grid>
      <br />
      <Grid container className={classes.root}>
        <br />
        <DataGrid
          onCellPrepared={cellPrepared}
          dataSource={dataSource}
          showBorders={true}
          columnAutoWidth={true}
          rowAlternationEnabled={false}
          allowColumnReordering={true}
          allowColumnResizing={true}
          columnResizingMode={modeSize}
          columnMinWidth={50}
          showScrollbar={true}
          keyExpr="Bill_of_Lading_Nbr"
          onExporting={onExporting}
        >
          <Scrolling
            rowRenderingMode="virtual"
            showScrollbar="always"
            useNative="false"
            scrollByThumb="true"
          ></Scrolling>
          <MasterDetail enabled={true} component={DataMyneMasterDetailView} />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible={true} />
          <Selection mode="multiple" />
          <SearchPanel
            visible={true}
            width={240}
            placeholder="Full Text Search..."
          />
          <Column
            dataField="ETD"
            caption="ETA"
            dataType="date"
            format="dd-MMM-yyyy"
            allowHiding={false}
          />
          <Column dataField="Bill_of_Lading_Nbr" allowHiding={false} />
          <Column dataField="Carrier" allowHiding={false} width={150} />
          <Column
            dataField="Shipper_Declared"
            caption="Shipper"
            allowHiding={false}
            width={150}
          />
          <Column dataField="Shipper_Declared_Address" visible={false} />
          <Column
            dataField="Consignee_Declared"
            caption="Consignee"
            allowHiding={false}
            width={150}
          />
          <Column dataField="Consignee_Declared_Address" visible={false} />
          <Column dataField="Notify_Name" visible={false} />
          <Column dataField="Notify_Address" visible={false} />
          <Column dataField="Master_Notify_Name" visible={false} />
          <Column dataField="Master_Notify_Address" visible={false} />
          <Column
            dataField="HS_Description"
            caption="HS Description"
            allowHiding={false}
            width={200}
          />
          <Column
            dataField="Port_of_Arrival"
            caption="Port of Arrival"
            allowHiding={false}
            width={150}
          />
          <Column
            dataField="VOCC"
            caption="VOCC"
            allowHiding={false}
            width={150}
          />
          <Column
            dataField="HS_Code_6"
            caption="HS Code"
            visible={false}
            width={150}
          />
          <Column
            dataField="Teus_Quantity"
            caption="Teus"
            allowHiding={false}
          />
          <Column
            dataField="Container_Quantity_20"
            caption="20'"
            allowHiding={false}
          />
          <Column
            dataField="Container_Quantity_40"
            caption="40'"
            allowHiding={false}
          />
          <Column
            dataField="Container_Quantity_45"
            caption="40'HC"
            allowHiding={false}
          />
          <Column
            dataField="Container_Size_Others"
            caption="Other"
            allowHiding={false}
          />
          <Column dataField="CTNR" caption="CTNR" allowHiding={false} />
          <Column
            dataField="NVOCC"
            caption="NVOCC"
            allowHiding={false}
            width={200}
          />
          <Column
            dataField="Consignee_City"
            caption="CNEE City"
            allowHiding={false}
          />
          <Column
            dataField="Consignee_State"
            caption="CNEE State"
            allowHiding={false}
          />
          <Column dataField="Weight" visible={false} />
          <Column dataField="Weight_Unit" visible={false} />
          <Column dataField="Quantity" visible={false} />
          <Column dataField="Quantity_Unit" visible={false} />

          <ColumnChooser enabled={true} mode={mode}>
            <Position
              my="right top"
              at="right bottom"
              of=".dx-datagrid-column-chooser-button"
            />

            <ColumnChooserSearch
              enabled={searchEnabled}
              editorOptions={searchEditorOptions}
            />

            <ColumnChooserSelection
              allowSelectAll={allowSelectAll}
              selectByClick={selectByClick}
              recursive={recursive}
            />
          </ColumnChooser>
          <LoadPanel enabled={true} />
          <Export enabled={true} allowExportSelectedData={true} />
          <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
          <Paging defaultPageSize={25} />
        </DataGrid>
      </Grid>
    </Container>
  );
}
